//子级router-view承载
import Center from '@/components/common/center'

//入库管理
import twzj_in_list from '@/pages/tuihuozhijian/in/list'
import twzj_in_forecast from '@/pages/tuihuozhijian/in/forecast'
import twzj_in_pendding from '@/pages/tuihuozhijian/in/pendding'
//库存sku
import twzj_stock_list from '@/pages/tuihuozhijian/stock/list'
//待出库
import WaitOut from '@/pages/yikuhuanbiao/stock/wait.out'
//导入出库单
import SKUImport from '@/pages/yikuhuanbiao/stock/sku.import'

//库房管理---出库管理
import Out from '@/pages/tuihuozhijian/out/list'
//导入出库单
import ExportOut from '@/pages/tuihuozhijian/out/export.out'
//打印网页
import PrintPage from '@/pages/tuihuozhijian/out/print.page'

//上传快递单
import UploadExp from '@/pages/tuihuozhijian/out/upload.express'

//一件代发批次
import twzj_one_batch from '@/pages/tuihuozhijian/one/batch'
//一件代发批次详情
import twzj_one_batch_list from '@/pages/tuihuozhijian/one/list'
//一件代发导入
import twzj_one_batch_import from '@/pages/tuihuozhijian/one/import'
//废弃管理
import twzj_discard_list from '@/pages/tuihuozhijian/discard/list'
//废弃单导入
import twzj_discard_import from '@/pages/tuihuozhijian/discard/import'
//质检异常
import zhijianyichang from '@/pages/tuihuozhijian/zhijianyichang/list'

//质检单管理--列表
import zhijiandan from '@/pages/tuihuozhijian/zhijiandan/list'

export default [{
  path: '/tuihuozhijian',
  component: Center,
  redirect: '/tuihuozhijian/in',
  meta: {
    title: '退货质检'
  },
  children: [{
    path: '/tuihuozhijian/in',
    component: Center,
    redirect: '/tuihuozhijian/in',
    meta: {
      title: "入库包裹"
    },
    children: [{
      path: '/tuihuozhijian/in',
      component: twzj_in_list,
      meta: {
        title: "已入库包裹"
      },
    }, {
      path: '/tuihuozhijian/in/forecast',
      component: twzj_in_forecast,
      meta: {
        title: "入库预报"
      },
    }, {
      path: '/tuihuozhijian/in/pendding',
      component: twzj_in_pendding,
      meta: {
        title: "待质检区"
      },
    }]
  }, {
    path: '/tuihuozhijian/stock',
    component: Center,
    redirect: '/tuihuozhijian/stock',
    meta: {
      title: "库存SKU"
    },
    children: [{
      path: '/tuihuozhijian/stock',
      component: twzj_stock_list,
      meta: {
        title: "库存SKU"
      },
    }, {
      path: '/Warehouse/sku/import',
      component: SKUImport,
      meta: {
        title: "导入SKU信息"
      },
    }]
  }, {
    path: '/tuihuozhijian/out',
    component: Center,
    redirect: '/tuihuozhijian/out',
    meta: {
      title: "出库单"
    },
    children: [{
      path: '/tuihuozhijian/out',
      component: Out,
      meta: {
        title: "出库单"
      },
    }, {
      path: '/tuihuozhijian/out/export',
      component: ExportOut,
      meta: {
        title: "导入出库单"
      },
    }, {
      path: '/tuihuozhijian/out/pending',
      component: WaitOut,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/tuihuozhijian/out/upload',
      component: UploadExp,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/tuihuozhijian/out/print',
      component: PrintPage,
      meta: {
        title: '打印'
      },
    }]
  }, {
    path: '/tuihuozhijian/one',
    component: Center,
    redirect: '/tuihuozhijian/one',
    meta: {
      title: '一件代发'
    },
    children: [{
        path: '/tuihuozhijian/one',
        component: twzj_one_batch,
        meta: {
          title: '一件代发批次'
        },
      },
      {
        path: '/tuihuozhijian/one/list',
        component: twzj_one_batch_list,
        meta: {
          title: '一件代发批次详情'
        },
      }, {
        path: '/tuihuozhijian/one/import',
        component: twzj_one_batch_import,
        meta: {
          title: '一件代发导入'
        },
      }
    ]
  }, {
    path: '/tuihuozhijian/discard',
    component: Center,
    redirect: '/tuihuozhijian/discard',
    meta: {
      title: "废弃单"
    },
    children: [{
      path: '/tuihuozhijian/discard',
      component: twzj_discard_list,
      meta: {
        title: "废弃单"
      },
    }, {
      path: '/tuihuozhijian/discard/import',
      component: twzj_discard_import,
      meta: {
        title: "导入废弃单"
      },
    }]
  }, {
    path: '/tuihuozhijian/zhijianyichang',
    component: zhijianyichang,
    meta: {
      title: "质检异常"
    },
  }, {
    path: '/tuihuozhijian/zhijiandan',
    component: zhijiandan,
    meta: {
      title: "质检单管理"
    },
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/tuihuozhijian.js